import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';

import styles from './OverseasInformation.module.scss';

type Props = {
  classes?: Partial<{
    container: string;
  }>;
};

export default function OverseasInformation({ classes }: Props): JSX.Element {
  const { t } = useTranslation(['checkout']);

  return (
    <div className={classNames(styles.container, classes?.container)}>
      <p className={styles.title}>{t('DOM_INFOS_TITLE')}</p>
      <p className={styles.content}>
        <Trans i18nKey={'DOM_INFOS_CONTENT'} namespace={'checkout'} />
      </p>
    </div>
  );
}
